<template>
  <div>
    <fields v-model="data.args" :fields="interfaceFields" :disabled="disabled"></fields>
    <submit-field @click="submit" :disabled="disabled || !editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  /** defaults example:
   * {
   *   parameters: [
   *     {
   *       key: 'port',
   *       label: '设备 ID',
   *       type: 'string',
   *       prefix: '#'
   *     },
   *     {
   *       key: 'type',
   *       label: '设备类型',
   *       type: 'select',
   *       options: [
   *         {
   *           key: 'PLC',
   *           value: 'PLC'
   *         }
   *       ],
   *       required: false
   *     }
   *   ],
   *   args: {
   *     port: '#uart-1'
   *   }
   * }
   */
  import Fields from '@/components/utils/fields'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    name: 'vue-form',
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        data: {
          args: {}
        }
      }
    },
    components: {
      Fields,
      SubmitField
    },
    methods: {
      refresh () {
        Object.keys(this.data.args).forEach(key => this.$delete(this.data.args, key))

        for (let [key, value] of Object.entries(this.defaults.args || [])) {
          this.$set(this.data.args, key, value)
        }
      },
      type2Field (type) {
        let map = {
          string: 'input-field',
          number: 'input-field',
          select: 'select-field',
          password: 'password-field'
        }

        return map[type]
      },
      submit () {
        let data = Object.create(null)

        data.args = this.defaults.parameters.reduce((acc, value) => {
          let key = value.key

          acc[key] = this.data.args[key]

          return acc
        }, Object.create(null))

        this.$emit('submit', data.args)
      }
    },
    created () {
      this.refresh()
    },
    computed: {
      interfaceFields () {
        let fields = []

        for (let parameter of this.defaults.parameters) {
          let field = {
            name: parameter.key,
            field: this.type2Field(parameter.type),
            props: {
              label: parameter.label,
              prefix: parameter.prefix,
              invalidFeedback: parameter.invalidFeedback,
              required: parameter.required,
              placeholder: parameter.placeholder
            }
          }

          if (parameter.type === 'select') {
            field.props.list = parameter.options
          }

          fields.push(field)
        }

        return fields
      },
      isValid () {
        // return this.interfaceFields.length > 0 && this.interfaceFields.every(iface => !!this.data.args[iface.name] || (iface.props.required === false))
        return true
      }
    },
    watch: {
      defaults () {
        this.refresh()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/vue-form.vue